export const addSection = (state, section) => {
  state.sections.push(section)
}

export const updateScrollY = (state, val) => {
  state.scrollPos = val
}

export const setActiveSection = (state, to) => {
  state.activeSection = to
}

export const setAnimatingScrollState = (state, to) => {
  state.isAnimatingScroll = to
}

export const setSiteLoadedState = (state, to) => {
  state.siteIsLoaded = to
}

export const setScrollLockedState = (state, to) => {
  state.scrollLocked = to
}

export const setLocale = (state, to) => {
  state.locale = to;
}

export const setChatOnline = (state, to) => {
  state.chatOnline = to;
}




// WEBPACK FOOTER //
// ./src/store/mutations.js